import { useEffect } from 'react';
import { internalLog } from '@ecom-zform/core';
import { useChangeFormError } from './use-change-form-error';
import { useFormState } from "./use-form-state";
function setFormDisableValidateStatus(form, bool) {
    form.setState({
        disableValidate: bool,
    }, internalLog("useAutoDisableValidate set disableValidate -> " + bool, form));
}
/**
 * 组件卸载时关闭校验
 * @param form
 * @param disable
 */
export function useAutoDisableValidate(form, disable) {
    if (disable === void 0) { disable = false; }
    useChangeFormError(form, 'useAutoDisableValidate');
    var visible = useFormState(form, 'visible');
    useEffect(function () {
        if (!disable) {
            if (visible) {
                setFormDisableValidateStatus(form, false);
            }
            else {
                setFormDisableValidateStatus(form, true);
            }
        }
    }, [visible]);
    useEffect(function () {
        return function () {
            if (!disable) {
                setFormDisableValidateStatus(form, true);
            }
        };
    }, []);
}
